import React, {
    useState, useContext, useCallback, useEffect, useMemo
} from 'react';
import _ from 'lodash';
import { withRouter, useHistory } from 'react-router-dom';
import { TranslatorContext, IntlContext } from '@jutro/locale';
import { useDataRefresh, ViewModelForm, ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import { WizardPage, wizardProps, WizardPageTemplate } from 'gw-portals-wizard-react';
import { useDependencies } from 'gw-portals-dependency-react';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { useValidation } from 'gw-portals-validation-react';
import UploadComponentForSTP from '../../sasria-capability-fnol-common-react/UploadComponentForSTP/UploadComponentForSTP';
import metadata from './STPUploadPhotosPage.metadata.json5';
import styles from './STPUploadPhotosPage.module.scss';
import messages from '../../gw-capability-fnol-common-react/FNOL.messages';
import Claim from '../../gw-capability-fnol-common-react/models/Claim';

function STPUploadPhotosPage(props) {
    const {
        wizardData: claimVM, updateWizardData, authHeader,
        history: {
            location: { state }
        }
    } = props;
    const history = useHistory();

    const translator = useContext(TranslatorContext);
    const { FNOLService } = useDependencies('FNOLService');
    const { onValidate, isComponentValid, registerComponentValidation } = useValidation(
        'STPUploadPhotosPage'
    );

    const onNext = useCallback(() => {
        return claimVM
    }, [translator, FNOLService, claimVM.value, authHeader, state, history]);

    const overrides = {

        expressClaimGrid: {
            visible: claimVM.value.sasriaExpressClaimDetails_EXT.isExpressClaimSelected
        },
        expressClaimSTP: {
            value: claimVM.value.sasriaExpressClaimDetails_EXT.isExpressClaimSelected
        },
        //documentUploadForSTP: {
           // path: !_.isUndefined(claimVM) ? claimVM : null,
           // updatePath: updateWizardData,
           // visible: claimVM.value.sasriaExpressClaimDetails_EXT.isExpressClaimSelected,
            //docListForSpecificSteps: claimVM.value.documentCheckList_EXT,
        //},
    };
    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            uploadComponentforSTP: UploadComponentForSTP
        }
    };

    return (
        <WizardPage
            //nextLabel={translator(messages.fnolSubmitClaim)}
            onNext={onNext}
            cancelLabel={translator(messages.fnolCancel)}
            disableNext={!isComponentValid}
            template={WizardPageTemplate}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                overrideProps={overrides}
                onModelChange={updateWizardData}
                onValidationChange={onValidate}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
            />
        </WizardPage>
    );
}
STPUploadPhotosPage.propTypes = wizardProps;
export default withRouter(withAuthenticationContext(STPUploadPhotosPage));
